export default __webpack_public_path__ + "static/media/appguide_img.6da925ab.png";